import * as React from 'react';

import GlobeBadge16 from './GlobeBadge16';

export const globeBadge16 = () => <GlobeBadge16 />;

export default {
    title: 'Icon|Line|GlobeBadge16',
    component: GlobeBadge16,
    parameters: {
        notes: "`import GlobeBadge16 from 'box-ui-elements/es/icon/line/GlobeBadge16';`",
    },
};
